/**
 * Feature 4: Sale Countdown Timer
 * Save as: assets/behuli-sale-countdown.js
 * Load in theme.liquid before </body>:
 *   <script src="{{ 'behuli-sale-countdown.js' | asset_url }}" defer></script>
 */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function tick(el, endTime) {
    const timer = el.querySelector('[data-timer]');
    if (!timer) return;

    function update() {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        el.classList.add('is-expired');
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      if (d > 0) {
        timer.textContent = `${d}d ${pad(h)}h ${pad(m)}m`;
      } else {
        timer.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
      }
    }

    update();
    setInterval(update, 1000);
  }

  function initAll() {
    document.querySelectorAll('.behuli-countdown:not([data-cd-ready])').forEach(el => {
      el.dataset.cdReady = '1';
      const endTime = Date.parse(el.dataset.end);
      if (!isNaN(endTime)) tick(el, endTime);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
